import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Observable } from 'rxjs';
import { VoiceCoreService } from 'src/app/talent-litmus-core/game-core/level1-core/voice-core';

@Injectable()
export class VoiceService {
  voiceList$ = this._voiceCoreService.voiceList$;

  pageSize: number;
  pageIndex: number;
  selectedId: string;
  cordX: number;
  cordY: number;
  searchParam: string;
  constructor(private _voiceCoreService: VoiceCoreService) {
    this._voiceCoreService.paginationState$.subscribe((state) => {
      this.pageIndex = state.pageIndex;
      this.pageSize = state.pageSize;
      this.selectedId = state.selectedId;
      this.cordX = state.x;
      this.cordY = state.y;
      this.searchParam = state.searchParam;
    });
  }

  addVoice(data): Observable<any> {
    return this._voiceCoreService.addVoice(data);
  }

  editVoice(data): Observable<any> {
    return this._voiceCoreService.editVoice(data);
  }

  deleteVoice(data): Observable<any> {
    return this._voiceCoreService.deleteVoice(data);
  }

  moveToLastPage(): void {
    this._voiceCoreService.moveToLastPage();
  }

  pageChangeEvent(event: PageEvent): void {
    this._voiceCoreService.pageChangeEvent(event);
  }

  setScrollPostion(scrollPostion: [number, number]): void {
    this._voiceCoreService.setScrollPosition(scrollPostion);
  }

  setSelectedId(id: string): void {
    this._voiceCoreService.setSelectedId(id);
  }

  setSearchParam(searchParam: string): void {
    this._voiceCoreService.setSearchParam(searchParam);
  }

  refresh(): void {
    this._voiceCoreService.refresh(true);
  }
}
